export const language: any ={
    LabelLogin:"Login",
    LabelForgotPw:"Find password",
    LabelSignUp:"Join the membership",
    LabelRememberMe:"Stay logged in",
    Or:"or",
    Email:"Email",
    Password:"Password",
    LangKo:"한국어",
    LangEn:"영어",
    LangVi:"베트남어",
    LabelCondition:"Agree to terms and conditions",
    FullAgreement:"Totally agree",
    Next:"Next",
    PrivacyPolicy:`Privacy Policy <span class="text-[#ff6741]">(required)</span>`,
    TermOfUse:`Terms of Use <label class="text-[#ff6741]">(required)</label>`,
    VerifyPassword:"Verify password",
    PlaceHolderPassword:"Enter at least 8 letters + numbers + special characters",
    DuplicateCheck:"Duplicate Check",
    LabelIdEmail:"ID (email)",
    GN_02_MSG_01:"Phiên bản ứng dụng của bạn đã cũ. Vui lòng nâng cấp để tiếp tục sử dụng.",
    AU_02_MSG_02:"This email is already registered, please use a different email.",
    AU_02_MSG_03:"The email is available.",
    AU_02_MSG_01:"Please enter a valid email format.",
    AU_01_MSG_01:"Incorrect ID or password. Please try again.",
    AU_02_MSG_04:"Please check the available email.",
    AU_02_MSG_05:"Please enter a password of at least 8 characters, including English letters, numbers, and special characters.",
    AU_02_MSG_06:"Password confirmation does not match.",
    AU_03_MSG_01:"Please enter a valid email format.",
    AU_03_MSG_02:"The email is not registered in the system.",
    AU_03_MSG_04:"※ A verification code has been sent to the registered email.",
    LabelRegisterComplete:"Membership registration is complete!",
    LabelLoginToUseService:"Log in and use the service.",
    LabelDontRememberPassword:"Forgot your password?",
    LabelYouCanFindEmail:"You can find it through email verification.",
    LabelPasswordTemporarySendToEmail:"※ A temporary password will be sent to the email you signed up with.",
    SendVerifyNumber:"Send authentication number",
    LabelCheckYourEmailForTemporaryPassword:"Please check your email for temporary password.",
    PlaceHolderTemporaryPassword:"Enter temporary password",
    LabelTemporaryPassword:"Temporary password",
    // LabelYouCanResendItAfter:`비밀번호를 못받으셨나요? {time} 후 재전송 할 수 있습니다.`,
    LabelDidntReceiveYourPassword:`Didn't receive your password? `,
    LabelYouCanResendItAfter:`You can resend after`,
    LabelYouCanResendAgain:`You can resend.`,
    Confirm:`Check`,
    Resend:`Retransmit`,
    LabelResetPassword:"Reset password",
    NewPassword:"New password",
    ConfirmNewPassword:"Verify password",
    PlaceHolderConfirmPassword:"Xác nhận mật khẩu",
    CurrentPassword:"Current password", //menu
    LanguageSetting:"Language Setting", //menu
    LeaveMembership:"Cancel membership", //menu
    LabelConfirmPasswordToLeaveMemberShip:"Please check your password to cancel your membership.", //menu
    LabelConfirmPasswordMeansYouAgreeAllContent:"Confirming your password means that you have read and agree to all guide contents.", //menu
    LabelCancelMembership:"Cancel membership", //menu
    LabelBeforeLeaveYouCheckedContent:"Before withdrawing, you must check the instructions below and check to agree.", //menu
    LabelAfterLeaveAllInfoWillRemove:"After withdrawal, all member information and usage records will be deleted and cannot be recovered.", //menu
    LabelIHaveReadAndAgreeContent:"I have read all instructions and agree to them.", //menu
    ToUnsubscribe:"Unsubscribe", //menu
    LabelWouldYouWantLogout:"Would you like to logout?", //menu
    ChangePassword:"Change Password", //menu
    Menu:"Menu", //menu
    MenuLanguageSettings:"Language settings", //menu
    MenuPrivacyPolicy:"Privacy policy", //menu
    MenuLogout: "Logout", //menu
    MenuLeaveMembership: "Withdrawal of membership", //menu
    LabelAreYouSureLeaveMembership: "Are you sure you want to withdraw?", //menu
    LabelIfLeaveMembershipAllInfoWillRemove: "If you cancel, your account information will be deleted and cannot be recovered.", //menu
    LabelPrivacyPolicy: "Privacy Policy",
    LabelTermOfUse:"Terms of Use",
    MI_02_MSG_01 : "Your current password is incorrect.",
    LabelModalLogin: `Login or sign up to access this feature.`,
    LabelIdLogin: "ID Login",
    LabelSnsApple: "Continue with Apple",
    LabelSnsFacebook: "Continue with Facebook",
    LabelSnsGoogle: "Continue with Google",
    LabelItemLogin: "Log in or sign up to explore a <br/>variety of features with Hey!Cooker",
    LabelSnsEmail: "E-mail Log in",
    LoadingLogin:"Please wait a moment." ,
    MenuNotificationSettings: "Notification Settings", //menu
}

